import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-208a538e")

_pushScopeId("data-v-208a538e")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "data second promo-event" }
const _hoisted_3 = { class: "data second promo-event" }
const _hoisted_4 = { class: "input-border first" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Název tipu a triku", -1)
const _hoisted_7 = { class: "group" }
const _hoisted_8 = { class: "border-gr short" }
const _hoisted_9 = { class: "input-border" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Obrázek na homepage", -1)
const _hoisted_12 = { class: "group" }
const _hoisted_13 = { class: "border-gr short date" }
const _hoisted_14 = { class: "data second promo-event" }
const _hoisted_15 = { class: "input-border first" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "text" }, "JSON soubor s obsahem", -1)
const _hoisted_18 = { class: "group" }
const _hoisted_19 = { class: "border-gr short date" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.faq !== undefined)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h2", null, "Jazyk: " + _toDisplayString(_ctx.faq.lang.toUpperCase()), 1)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("input", {
                  type: "text",
                  autocomplete: "nope",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('set-title', _ctx.faq.lang, $event.target.value))),
                  value: _ctx.faq.page_title
                }, null, 40, ["value"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("input", {
                  id: "image",
                  type: "file",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectContentImageFile && _ctx.selectContentImageFile(...args)))
                }, null, 32)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("input", {
                  id: "file",
                  type: "file",
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
                }, null, 32)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})